/**
 * Routes where the header WorkspaceSwitcher is hidden because a workspace picker makes no sense there.
 * One list for the desktop header and the mobile sheet (ModernMainLayout).
 *
 * - /clients: the Clients section is contract-scoped, not workspace-scoped (Jacob, 2026-09-08).
 * - /ads-tools/client-dashboard: a FLEET view (one row per tenant); a switcher would imply it scopes to
 *   one tenant, which it never does (CORE-D-01.c, Jacob 2026-09-18).
 * - /admin and everything below it (Admin Panel, Research Coverage, LLM Benchmarks ...): platform-wide
 *   pages, "the picker doesn't make sense" (Jacob, 2026-10-05, O57).
 */
export const HIDE_WORKSPACE_SWITCHER_PREFIXES = [
  "/admin",
  "/clients",
  "/ads-tools/client-dashboard",
] as const;

/** True when the path is one of the prefixes or below it (matched at a path-segment boundary). */
export function shouldHideWorkspaceSwitcher(pathname: string): boolean {
  return HIDE_WORKSPACE_SWITCHER_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}
